/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'connection-show': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M20.7 17.1v2.5c0 1.2.9 2.1 2 2.2v4.8l-4.1 4.3h-1c-.1-1.1-1.1-2-2.2-2h-2.5c-1.2 0-2.2 1-2.2 2.2v2.5c0 1.2 1 2.2 2.2 2.2h2.5c1.2 0 2.1-.9 2.2-2h10c.1 1.1 1.1 2 2.2 2h2.5c1.2 0 2.2-1 2.2-2.2v-2.5c0-1.2-1-2.2-2.2-2.2h-2.5c-1.2 0-2.1.9-2.2 2h-4.9l2.5-2.6c.3-.3.4-.7.4-1v-5.4c1.1-.1 2-1.1 2-2.2v-2.5c0-1.2-1-2.2-2.2-2.2h-2.5c-1.2-.2-2.2.8-2.2 2.1zm-7.8 16.7c-.1 0-.2-.1-.2-.2v-2.5c0-.1.1-.2.2-.2h2.5c.1 0 .2.1.2.2v2.5c0 .1-.1.2-.2.2h-2.5zm19.5-3c.1 0 .2.1.2.2v2.5c0 .1-.1.2-.2.2h-2.5c-.1 0-.2-.1-.2-.2V31c0-.1.1-.2.2-.2h2.5zm-7-14c.1 0 .2.1.2.2v2.5c0 .1-.1.2-.2.2h-2.5c-.1 0-.2-.1-.2-.2V17c0-.1.1-.2.2-.2h2.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/connection-show.js